/**
 * L2-R6: moved to @miq/platform-ui (dialogs/edp-edit-failed/edp-edit-failed.component.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform-ui'.
 */
export { EdpEditFailedComponent } from '@miq/platform-ui';
